import { useApi } from '@hooks/useApi';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';

export type TdsSyncResult = {
  resultcode: string;
  result: string;
  message: string;
};

type TdsSyncResponse = {
  results: TdsSyncResult[];
};

export function useSyncToTds({
  id,
  callback,
}: {
  id: string;
  callback: (results: TdsSyncResult[]) => void;
}) {
  const { query } = useApi();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: (): Promise<TdsSyncResponse> => {
      return query({
        path: `v1/staff/merchants/${id}/sync_to_tds`,
        opt: {
          method: 'POST',
        },
      });
    },
    onSuccess: async (data) => {
      await queryClient.refetchQueries({ queryKey: [...queryKeys.merchant, id] });
      callback(data.results);
    },
  });

  return {
    mutate,
    isPending,
  };
}
